// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
export const MIN_ROW_SPAN = 2;
export const MIN_COL_SPAN = 1;
export const TRANSITION_DURATION_MS = 200;
//# sourceMappingURL=constants.js.map